import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/base/SEOHead';

export default function Disclaimer() {
  return (
    <>
      <SEOHead
        title="Disclaimer — LitBuy Spreadsheet"
        description="Please read this disclaimer carefully before using litbuyspreadsheets.one. Understand the informational purpose, affiliation status, content accuracy, and limitation of liability."
        canonicalPath="/disclaimer"
        pageType="website"
        breadcrumbData={[
          { name: 'Home', path: '/' },
          { name: 'Disclaimer', path: '/disclaimer' },
        ]}
      />
      <Navbar />
      <main className="min-h-screen">
        <div className="bg-background-100 py-14 md:py-20">
          <div className="max-w-3xl mx-auto px-4 md:px-6">
            <nav className="text-xs text-foreground-500 mb-6" aria-label="Breadcrumb">
              <Link to="/" className="hover:text-primary-500 transition-colors">Home</Link>
              <span className="mx-2">/</span>
              <span className="text-foreground-700">Disclaimer</span>
            </nav>
            <h1 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
              Disclaimer
            </h1>
            <p className="mt-4 text-foreground-600 text-base leading-relaxed max-w-2xl">
              Please read this disclaimer carefully before using litbuyspreadsheets.one. By using this website, you accept the terms outlined below.
            </p>
          </div>
        </div>

        <article className="max-w-3xl mx-auto px-4 md:px-6 py-12 md:py-16">
          <section className="mb-10">
            <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-4">Informational Purpose</h2>
            <p className="text-foreground-700 leading-relaxed mb-3">
              LitBuy Spreadsheet Resource Center (litbuyspreadsheets.one) is an independent informational website. All content provided on this site — including articles, guides, comparisons, and templates — is for informational and educational purposes only. We strive to provide accurate, up-to-date information, but we make no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, suitability, or availability of the information contained on the website.
            </p>
            <p className="text-foreground-700 leading-relaxed">
              Any reliance you place on such information is strictly at your own risk. We recommend verifying any critical information through official channels before making decisions based on content found on this site.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-4">Affiliation Disclaimer</h2>
            <p className="text-foreground-700 leading-relaxed mb-3">
              This website is not directly affiliated with, endorsed by, or sponsored by LitBuy Spreadsheet or any related entity unless explicitly stated. Product names, logos, brands, and other trademarks featured or referred to within this website are the property of their respective trademark holders.
            </p>
            <p className="text-foreground-700 leading-relaxed">
              Any references to third-party products, services, or websites do not constitute an endorsement. We provide links to external websites, including kaspreadsheet.com, as a convenience to our readers. We are not responsible for the content, accuracy, or practices of these external sites.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-4">Content Accuracy</h2>
            <p className="text-foreground-700 leading-relaxed mb-3">
              While we make reasonable efforts to keep the information on this website current and correct, we do not guarantee that the content is free from errors or omissions. Features, pricing, and specifications of products discussed on this site may change over time. We encourage readers to verify details directly with the official LitBuy Spreadsheet platform or kaspreadsheet.com before making purchasing decisions.
            </p>
            <p className="text-foreground-700 leading-relaxed">
              Our comparison articles and reviews reflect the knowledge and opinions of our editorial team based on information available at the time of writing. These may not capture the most recent updates or feature releases.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-4">Limitation of Liability</h2>
            <p className="text-foreground-700 leading-relaxed mb-3">
              In no event shall litbuyspreadsheets.one or its operators be liable for any loss or damage, including without limitation indirect or consequential loss or damage, arising from the use of or reliance on any information provided on this website.
            </p>
            <p className="text-foreground-700 leading-relaxed">
              This includes but is not limited to business losses, loss of data, loss of profits, or any other financial damages. Your use of any information or materials on this website is entirely at your own risk, for which we shall not be liable.
            </p>
          </section>

          <section className="mb-10">
            <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-4">External Links Policy</h2>
            <p className="text-foreground-700 leading-relaxed mb-3">
              Through this website, you can link to other websites which are not under the control of litbuyspreadsheets.one. We have no control over the nature, content, and availability of those sites. The inclusion of any links does not necessarily imply a recommendation or endorse the views expressed within them.
            </p>
            <p className="text-foreground-700 leading-relaxed">
              All outgoing links to external websites use rel=&quot;noopener nofollow&quot; attributes. This is a standard security practice that prevents the destination site from accessing the originating page through the window.opener JavaScript object and indicates to search engines that we do not vouch for the linked content.
            </p>
          </section>

          <div className="mt-8 pt-6 border-t border-background-200/70">
            <p className="text-xs text-foreground-500 mb-3">
              Last updated: June 2026. If you have questions about this disclaimer, please visit our main website.
            </p>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors"
            >
              Visit kaspreadsheet.com
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </article>
      </main>
      <Footer />
    </>
  );
}